import * as z from "zod/v4";

export const submitMerchantFeedback = {
  name: "submitMerchantFeedback" as const,
  input: z.object({
    comment: z.string().trim().min(1).max(500),
    pageUrl: z.string().max(2000).optional(),
  }),
  output: z.object({ success: z.literal(true) }),
};
